import ColoredHeader from './ColoredHeader';

export default ColoredHeader;
